module.exports = __webpack_public_path__ + "img/arrows-retweet.1eadab9f.svg";